import useSWR from "swr";

import INotification from "@/interfaces/notification.interface";
import notificationService from "@/services/notification.service";

const useGetNotificationById = (notificationId: number) => {
  const { data, error, isLoading } = useSWR(
    notificationId ? `notification-${notificationId}` : null,
    () => notificationService.getById(notificationId)
  );

  return {
    data,
    isLoading,
    error,
  };
};

export default useGetNotificationById;
